/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _menu = __webpack_require__(1);

	var _menu2 = _interopRequireDefault(_menu);

	var _equalHeights = __webpack_require__(3);

	var _equalHeights2 = _interopRequireDefault(_equalHeights);

	var _sliders = __webpack_require__(4);

	var _sliders2 = _interopRequireDefault(_sliders);

	var _stickyHeader = __webpack_require__(5);

	var _stickyHeader2 = _interopRequireDefault(_stickyHeader);

	var _jsFormValidate = __webpack_require__(6);

	var _jsFormValidate2 = _interopRequireDefault(_jsFormValidate);

	var _messages = __webpack_require__(7);

	var _messages2 = _interopRequireDefault(_messages);

	var _select = __webpack_require__(8);

	var _select2 = _interopRequireDefault(_select);

	var _select2Ajax = __webpack_require__(9);

	var _select2Ajax2 = _interopRequireDefault(_select2Ajax);

	var _userMenu = __webpack_require__(10);

	var _userMenu2 = _interopRequireDefault(_userMenu);

	var _search = __webpack_require__(11);

	var _search2 = _interopRequireDefault(_search);

	var _tags = __webpack_require__(12);

	var _tags2 = _interopRequireDefault(_tags);

	var _sort = __webpack_require__(13);

	var _sort2 = _interopRequireDefault(_sort);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	jQuery(function () {
		// Site Menu
		_menu2.default.init();

		//Equal heights
		_equalHeights2.default.init();

		// Slick Slider
		_sliders2.default.init();

		// Sticky header
		_stickyHeader2.default.init();

		// Frontend form validation
		_jsFormValidate2.default.init();

		//Messages
		_messages2.default.init();

		// Select 2
		_select2.default.init();

		// Select 2 ajax
		_select2Ajax2.default.init();

		//User menu
		_userMenu2.default.init();

		// Search
		_search2.default.init();

		// Tags
		_tags2.default.init();

		// Sort
		_sort2.default.init();
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Menu = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domMenuBtn: $('.js-menu-btn'),
		$domMenuNav: $('.js-main-nav'),
		$domMenuHasSub: $('.js-main-nav .menu-item--expanded'),
		classOpen: 'open',
		classOpenMenu: 'menu-open',
		classSubMenu: '.menu-item--expanded > .menu',
		classSubIcon: '.sub-icon',
		classMenu: '.menu',
		classList: 'li',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// functions
			var closeNav = function closeNav() {
				Menu.$domMenuBtn.removeClass(Menu.classOpen);
				Menu.$domMenuNav.removeClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
				Menu.$domMenuNav.find(Menu.classSubIcon).removeClass(Menu.classOpen);
				_global2.default.$domBody.removeClass(Menu.classOpenMenu);
			};

			if (_global2.default.varsWindowWidth < 992) {
				Menu.$domMenuHasSub.each(function (i, el) {
					$(el).append('<span class="sub-icon font-plus-circle" data-open-sub></span>');
				});
			}

			// bind events
			Menu.$domMenuBtn.on('click', function (e) {
				e.preventDefault();
				Menu.$domMenuBtn.toggleClass(Menu.classOpen);
				Menu.$domMenuNav.toggleClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
				Menu.$domMenuNav.find(Menu.classSubIcon).removeClass('open');
				_global2.default.$domBody.toggleClass(Menu.classOpenMenu);
			});

			Menu.$domMenuNav.on('click', '[data-open-sub]', function (e) {
				var self = $(e.currentTarget);

				if (self.hasClass(Menu.classOpen)) {
					self.removeClass(Menu.classOpen).siblings(Menu.classSubMenu).slideUp();
					self.siblings().find(Menu.classSubIcon).removeClass(Menu.classOpen);
					self.siblings().find(Menu.classMenu).slideUp();
				} else {
					self.addClass(Menu.classOpen).siblings(Menu.classSubMenu).slideDown();
					self.parent().siblings(Menu.classList).find(Menu.classSubIcon).removeClass(Menu.classOpen);
					self.parent().siblings(Menu.classList).find(Menu.classMenu).slideUp();
				}
			});

			_global2.default.functions.clickOutsideContainer(Menu.$domMenuNav, Menu.$domMenuNav.find('ul'), Menu.$domMenuBtn, closeNav);

			_global2.default.functions.escKey(closeNav);
		}
	};

	exports.default = Menu;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Global = {
		$domWindow: $(window),
		$domDoc: $(document),
		$domBody: $('body'),

		varsWindowWidth: window.innerWidth,

		functions: {
			escKey: function escKey(callback) {
				Global.$domDoc.on('keyup', function (e) {
					if (e.keyCode === 27) {
						callback();
					}
				});
			},

			clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
				selector.on('mouseup', function (e) {
					e.preventDefault();
					if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
						callback();
					}
				});
			}
		}
	};

	exports.default = Global;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var EqualHeights = {
	  /*-------------------------------------------------------------------------------
	  	# Cache dom and strings
	  -------------------------------------------------------------------------------*/
	  /*-------------------------------------------------------------------------------
	  	# Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    // equal heights function
	    var equalHeights = function equalHeights(elm) {
	      setTimeout(function () {
	        var x = 0;

	        elm.height('auto');

	        elm.each(function (index, el) {
	          if ($(el).height() > x) {
	            x = $(el).height();
	          }
	        });

	        elm.height(x + 1);
	      }, 100);
	    };

	    //About the shipping industry
	    equalHeights($('.inline-images h5'));
	  }
	};

	exports.default = EqualHeights;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Sliders = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSlider: $('.js-slider'),
		$domSliderBanner: $('.js-slider-banner'),
		$domHomeSlider: $('.field-field_gallery_images'),
		$domHowItWorksSlider: $('.view-how-it-works-carousel .view-content'),

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			Sliders.$domSlider.slick({
				infinite: true,
				slidesToShow: 2,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: false,
				dots: true,
				responsive: [{
					breakpoint: 767,
					settings: {
						slidesToShow: 1
					}
				}]
			});

			Sliders.$domSliderBanner.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: true,
				dots: true,
				pauseOnHover: false,
				pauseOnFocus: false,
				fade: true,
				autoplaySpeed: 4000
			});

			Sliders.$domHomeSlider.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: true,
				dots: true,
				pauseOnHover: true,
				pauseOnFocus: true,
				fade: true,
				autoplaySpeed: 4000
			});

			Sliders.$domHowItWorksSlider.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				arrows: true,
				autoplay: false,
				dots: false,
				pauseOnHover: true,
				pauseOnFocus: true,
				fade: true,
				autoplaySpeed: 4000
			});
		}
	};

	exports.default = Sliders;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Sticky = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$header: $('.js-header'),
		$content: $('.js-site-content'),
		classSticky: 'sticky-header',
		classStickyContent: 'sticky-content',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			$(window).on('scroll', function () {
				if ($(window).scrollTop() >= 30) {
					Sticky.$content.addClass(Sticky.classStickyContent);
					Sticky.$header.addClass(Sticky.classSticky);
				} else {
					Sticky.$content.removeClass(Sticky.classStickyContent);
					Sticky.$header.removeClass(Sticky.classSticky);
				}
			});
		}
	};

	exports.default = Sticky;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var FormValidate = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		// Use this class for every form you whant to validate
		classForm: '.js-validation',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			if ($(FormValidate.classForm).length > 0) {
				$.validate({
					form: FormValidate.classForm
				});
			}
		}
	};

	exports.default = FormValidate;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Messages = {

	  init: function init() {

	    $(document).ready(function () {
	      $('div[role="contentinfo"]').append('<div class="close-button"></div>');

	      function closeFlashMessages() {
	        $('body').find('div[role="contentinfo"] .close-button').on('click', function (e) {
	          $('div[role="contentinfo"]').addClass('hide');
	        });
	      }

	      closeFlashMessages();

	      $(document).ajaxComplete(function () {
	        closeFlashMessages();
	      });
	    });
	  }
	};

	exports.default = Messages;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Select2 = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSelect: $('select'),

		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// drupal fix for multilingual
			var selectPlaceholder = Drupal.t("Select an option");

			Select2.$domSelect.select2({
				placeholder: '' + selectPlaceholder
			});
		}
	};

	exports.default = Select2;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _select = __webpack_require__(8);

	var _select2 = _interopRequireDefault(_select);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Select2Ajax = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			$(document).ajaxComplete(function () {
				_select2.default.init();
				$('select[id*="edit-sort-by"]').select2();
				$('select[id*="edit-field-tags"]').select2();
			});
		}
	};

	exports.default = Select2Ajax;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var UserMenu = {

	  init: function init() {

	    if ($('.c-main-navigation').find('#block-usermenu').length) {
	      $('body').addClass('user-logged-in');

	      $(document).on('click', '.user-name', function (e) {

	        var self = $(e.currentTarget);

	        if ($(self).parent().hasClass('block-usermenu--expanded')) {
	          $(self).parent().removeClass('block-usermenu--expanded');
	          $(self).siblings().removeClass('user-links__expanded');
	        } else {
	          $(self).parent().addClass('block-usermenu--expanded');
	          $(self).siblings().addClass('user-links__expanded');
	        }
	      });
	    }
	  }
	};

	exports.default = UserMenu;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var Search = {
	    /*-------------------------------------------------------------------------------
	    # Cache dom and strings
	    -------------------------------------------------------------------------------*/
	    $searchField: $('.search-form input.form-text'),

	    /*-------------------------------------------------------------------------------
	    # Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {

	        // Validation
	        function validation(element) {
	            if (element.length) {
	                var $button = element.closest('form').find('input[id*="edit-submit"]');

	                var isNumber = !isNaN(element.val());
	                var searchLength = isNumber ? element.val().trim().length > 1 : element.val().trim().length > 2;

	                if (searchLength) {
	                    $button.removeAttr('disabled');
	                    $button.css('pointer-events', 'initial');
	                } else {
	                    $button.attr('disabled', 'disabled');
	                    $button.css('pointer-events', 'none');
	                }
	            }
	        }

	        validation(Search.$searchField);

	        Search.$searchField.on('input', function (e) {
	            validation(Search.$searchField);
	        });
	    }
	};

	exports.default = Search;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var Tags = {
	    /*-------------------------------------------------------------------------------
	    # Cache dom and strings
	    -------------------------------------------------------------------------------*/
	    $popularTagsList: $('#block-populartagsblock'),
	    $allTagsList: $('.js-form-item-field-tags'),

	    /*-------------------------------------------------------------------------------
	    # Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {
	        var isPopularTags = void 0;

	        function getTags() {
	            var params = new URLSearchParams(location.search);

	            var param = params.get('tags');

	            if (param != '2') {
	                isPopularTags = true;
	            } else {
	                isPopularTags = false;
	            }
	        }

	        function toggleActive() {
	            getTags();

	            if (isPopularTags) {
	                Tags.$popularTagsList.show();
	                Tags.$allTagsList.hide();
	            } else {
	                Tags.$popularTagsList.hide();
	                Tags.$allTagsList.show();
	            }
	        }

	        toggleActive();

	        /**
	         * Reset filters
	         */

	        var fieldCollection = '';
	        var searchText = '';
	        var sortBy = '';
	        var allParams = '';

	        var $popularTagsBtn = $('.page-gallery #edit-tags-1');
	        var $allTagsBtn = $('.page-gallery #edit-tags-2');

	        function getUrlParams() {
	            var params = new URLSearchParams(location.search);

	            var searchParam = params.get('search_api_fulltext');
	            var collectionParam = params.get('field_collection');
	            var sortParam = params.get('sort_by');

	            if (searchParam) {
	                searchText = '&search_api_fulltext=' + searchParam;
	            }

	            if (collectionParam) {
	                fieldCollection = '&field_collection=' + collectionParam;
	            }

	            if (sortParam) {
	                sortBy = '&sort_by=' + sortParam;
	            }

	            allParams = searchText + fieldCollection + sortBy;
	        }

	        function resetPopularFilters() {
	            getUrlParams();

	            $popularTagsBtn.attr('href', '/gallery?tags=1' + allParams);
	        }

	        function resetAllFilters() {
	            getUrlParams();

	            $allTagsBtn.attr('href', '/gallery?tags=2' + allParams);
	        }

	        if (window.location.search.includes('tags=2')) {
	            resetAllFilters();
	        } else {
	            resetPopularFilters();
	        }
	    }
	};

	exports.default = Tags;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line

	var Sort = {
	    /*-------------------------------------------------------------------------------
	    # Cache dom and strings
	    -------------------------------------------------------------------------------*/
	    $submitButton: $('.page-gallery #edit-submit-gallery'),
	    $sortSelect: $('.page-gallery #edit-sort-by'),

	    /*-------------------------------------------------------------------------------
	    # Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {

	        function setSearchParams(param) {
	            if (window.location.search == '') {
	                window.location.search = 'search_api_fulltext=&sort_by=' + param;
	            } else {
	                var params = new URLSearchParams(window.location.search);

	                params.set('sort_by', param);
	                window.history.replaceState({}, '', window.location.pathname + '?' + params.toString());

	                Sort.$submitButton.removeAttr('disabled').trigger('click');
	            }
	        }

	        Sort.$sortSelect.on('select2:select', function () {
	            setSearchParams($(this).val());
	        });
	    }
	};

	exports.default = Sort;

/***/ })
/******/ ]);